import React from 'react';
import PropTypes from 'prop-types';
import { CheckRoundedFillSvg } from '../../assets/svgs';
import { ProgressBarStep, StepsProgress } from './steps-progress-bar.style';

const StepsProgressBarComponent = ({
    currentStep = 2,
    data = [
        { step: 1, label: 'Example 1' },
        { step: 2, label: 'Example 2' },
        { step: 3, label: 'Example 3' },
    ],
}) => {
    return (
        <StepsProgress>
            {
                data && data.length > 0 && data.map((step, index) => (
                    <ProgressBarStep key={index}>
                        {
                            step.step > currentStep ? (
                                <div>{index + 1}</div>
                            ) : step.step < currentStep ? (
                                <CheckRoundedFillSvg />
                            ) : (
                                <div className="active-step">{index + 1}</div>
                            )
                        }
                        <p>{step.label || `Step ${index + 1}`}</p>
                    </ProgressBarStep>
                ))
            }
        </StepsProgress>
    );
};

StepsProgressBarComponent.propTypes = {
    currentStep: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
};

export default StepsProgressBarComponent;
